export const Motif = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 2c1.5 3 4 5.5 7 7-3 1.5-5.5 4-7 7-1.5-3-4-5.5-7-7 3-1.5 5.5-4 7-7z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="9" r="0.9" fill="currentColor" />
  </svg>
);

export const MotifDivider = ({ label }) => (
  <div className="motif-divider my-10" data-testid="motif-divider">
    <Motif />
    {label && (
      <span className="eyebrow text-[var(--srishti-saffron)]">{label}</span>
    )}
    <Motif />
  </div>
);
